<template>
  <div id="app">
    <tool-bar />
    <main>
      <transition :name="transitionName">
      <!-- <transition name="fade"> -->
        <router-view></router-view>
      </transition>
    </main>
    <spinner :loading="loadingStatus"/>
  </div>
</template>

<script>
import ToolBar from './components/ToolBar.vue';
import Spinner from './components/Spinner.vue';
import bus from './utils/bus.js';

export default {
  components: {
    ToolBar,
    Spinner
  },
  data() {
    return {
      transitionName: "",
      loadingStatus: false
    };
  },
  methods: {
    startSpinner() {
      this.loadingStatus = true;
    },
    endSpinner() {
      this.loadingStatus = false;
    }
  },
  watch: {
    $route(to, from) {
      this.isNavigate = false;
      if (from.meta.type === 'ud' || to.meta.type === 'ud') {
        this.transitionName = to.meta.page > from.meta.page ? "up" : "down";
      } else if (to.meta.type === 'lr') {
        this.transitionName = to.meta.page > from.meta.page ? "next" : "prev";
      }
    }
  },
  created() {
    bus.$on('start:spinner', this.startSpinner);
    bus.$on('end:spinner', this.endSpinner);
  },
  beforeDestroy() {
    bus.$off('start:spinner', this.startSpinner);
    bus.$off('end:spinner', this.endSpinner);
  }
}
</script>

<style>
html,
body {
  height: 100%;
}
body {
  margin: 0;
}

a {
  color: #34495e;
  text-decoration: none;
}

a:hover {
  color: #42b883;
  text-decoration: underline;
}

a.router-link-exact-active {
  text-decoration: underline;
} 

#app {
  display: flex;
  flex-direction: column;
  min-height: 100%;
}

main {
  min-height: 100%;
  display: grid;
  grid-template: "main";
  flex: 1;
  position: relative;
  overflow: hidden;
  background-color: white;
}

main > * {
  grid-area: main; /* Transition: make sections overlap on same cell */
  flex: 1 1 auto;
  background-color: white;
  position: relative;
  height: 100vh; /* To be fixed */
}

main > :first-child {
  z-index: 1; /* Prevent flickering on first frame when transition classes not added yet */
}

/* Transitions */

/* fade */
.fade-enter-active, .fade-leave-active {
  transition: opacity 0.5s;
}

.fade-enter, .fade-leave-to {
  opacity: 0;
}

/* left-right */
.next-leave-to {
  animation: leaveToLeft 500ms both cubic-bezier(0.165, 0.84, 0.44, 1);
  z-index: 0;
}

.next-enter-to {
  animation: enterFromRight 500ms both cubic-bezier(0.165, 0.84, 0.44, 1);
  z-index: 1;
}

.prev-leave-to {
  animation: leaveToRight 500ms both cubic-bezier(0.165, 0.84, 0.44, 1);
  z-index: 1;
}

.prev-enter-to {
  animation: enterFromLeft 500ms both cubic-bezier(0.165, 0.84, 0.44, 1);
  z-index: 0;
}

@keyframes leaveToLeft {
  from {
    transform: translateX(0);
  }
  to {
    transform: translateX(-25%);
    filter: brightness(0.5);
  }
}

@keyframes enterFromLeft {
  from {
    transform: translateX(-25%);
    filter: brightness(0.5);
  }
  to {
    transform: translateX(0);
  }
}

@keyframes leaveToRight {
  from {
    transform: translateX(0);
  }
  to {
    transform: translateX(100%);
  }
}

@keyframes enterFromRight {
  from {
    transform: translateX(100%);
  }
  to {
    transform: translateX(0);
  }
}

/* up-down */
.up-leave-to {
  animation: leaveToUp 500ms both cubic-bezier(0.165, 0.84, 0.44, 1);
  z-index: 0;
}

.up-enter-to {
  animation: enterFromDown 500ms both cubic-bezier(0.165, 0.84, 0.44, 1);
  z-index: 1;
}

.down-leave-to {
  animation: leaveToDown 500ms both cubic-bezier(0.165, 0.84, 0.44, 1);
  z-index: 1;
}

.down-enter-to {
  animation: enterFromUp 500ms both cubic-bezier(0.165, 0.84, 0.44, 1);
  z-index: 0;
}

@keyframes leaveToUp {
  from {
    transform: translateY(0);
  }
  to {
    transform: translateY(-25%);
    filter: brightness(0.5);
  }
}

@keyframes enterFromUp {
  from {
    transform: translateY(-25%);
    filter: brightness(0.5);
  }
  to {
    transform: translateY(0);
  }
}

@keyframes leaveToDown {
  from {
    transform: translateY(0);
  }
  to {
    transform: translateY(100%);
  }
}

@keyframes enterFromDown {
  from {
    transform: translateY(100%);
  }
  to {
    transform: translateY(0);
  }
}
</style>
